import React, { useState } from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import FileUploader from './FileUploader';
import WorkflowForm from './WorkflowForm';

interface WorkflowSetupProps {
  onExecute: (executionArn: string) => void;
}

export default function WorkflowSetup({ onExecute }: WorkflowSetupProps) {
  const [files, setFiles] = useState<File[]>([]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 3, height: 'fit-content' }}>
          <Typography variant="h6" gutterBottom>
            Upload Documents
          </Typography>
          <FileUploader 
            files={files} 
            setFiles={setFiles}
            showNextButton={false}
          />
        </Paper>
      </Grid>
      
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Configure Workflow
          </Typography>
          <WorkflowForm 
            files={files} 
            onExecute={onExecute}
            disabled={files.length === 0}
          />
        </Paper>
      </Grid>
    </Grid>
  );
}